var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedstar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 104.534,
    height: 102.551,
    viewBox: "0 0 104.534 102.551",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_166",
    "data-name": "Rectangle 166",
    width: 104.534,
    height: 102.551,
    fill: "#f7707d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_825",
    "data-name": "Group 825",
    transform: "translate(-1640.733 -882.056)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_655",
    "data-name": "Group 655",
    transform: "translate(1640.733 882.057)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_648",
    "data-name": "Group 648",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43742",
    "data-name": "Path 43742",
    d: "M58.277,35.865C66.685,27.6,74.4,20.216,81.853,12.571c2.319-2.38,3.57-2.579,5.945-.033,5.827,6.248,5.976,6.118-.206,12.289C81.243,31.167,74.883,37.5,67.987,44.371c5.492,1.016,10.115.448,14.7.531,6.029.11,12.062.119,18.09-.011,2.615-.057,3.673.636,3.721,3.518.154,9.223.282,9.222-8.835,9.222H68.712l-.46,1.036L83.023,73.554q2.39,2.408,4.775,4.821c4.751,4.8,4.538,4.606.177,9.495-2.852,3.2-4.571,3.379-7.6.074-6.208-6.772-12.92-13.082-19.451-19.555-.59-.584-1.026-1.561-2.646-1.2,0,9.934-.158,19.971.08,30,.093,3.891-.646,5.6-5.07,5.337-6.8-.408-6.82-.094-6.82-7.115,0-9.295,0-18.589,0-28.082-2,.134-2.688,1.416-3.57,2.3C35.985,76.578,29.033,83.486,22.277,90.58c-2.08,2.183-3.291,2.054-5.349-.046-6.258-6.386-6.385-6.332,0-12.675,6.3-6.257,12.68-12.43,18.979-18.6-1.558-2.341-3.381-1.577-4.883-1.592-9.045-.082-18.091-.128-27.134.006-2.9.042-3.872-.842-3.884-3.848-.039-8.9-.174-8.9,8.733-8.9H36.194c.08-2.408-1.48-3.1-2.457-4.09C27.382,34.4,21.018,27.973,14.522,21.68c-1.844-1.787-1.783-2.863-.018-4.711,5.992-6.272,5.866-6.3,12.137-.077,6.369,6.317,12.845,12.524,19.825,19.313,0-10.123-.058-19.7.042-29.269.023-2.18-1.162-5.618.785-6.294C50.255-.386,53.837.057,57.11.363c1.822.17,1.124,2.2,1.132,3.412.062,8.894.034,17.788.035,26.682v5.408",
    transform: "translate(0 0)",
    fill: "#f7707d"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedstar);
export default __webpack_public_path__ + "static/media/redstar.9f4a4e5e2dea7ba25aef6da3d744ea1e.svg";
export { ForwardRef as ReactComponent };